export default "__VITE_ASSET__qD5zWoCk__"